module.exports = __webpack_public_path__ + "img/2019-11-12-pc.410297bd.png";